import EngineerTeamChannelContainer from '../../components/EngineerTeamChannelContainer'

export default function EngineerDashboardTeamChannel() {
  return (
    <div className="">
      <EngineerTeamChannelContainer />
    </div>
  )
}
